import { formatCurrency } from "../helpers/currency-formatting-util.js";
import chartBuilderBase from "./chartBuilderBase.js";
import chartDisplaySettings from "./chartDisplaySettings.js";
import periodSelection from "./periodSelection.js";

/**
 * Builds default plotOptions http://api.highcharts.com/highcharts#plotOptions.series
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function seriesPlotOptionsBuilder(spec, my) {
	spec ||= {};
	my ||= {};

	let pointOptions = {};
	let selectedPointOptions = {};

	const builderSpec = Object.create(spec);

	builderSpec.options = chartBuilderBase.mergeOptions(
		builderSpec.options || {},
		{
			followPointer: false,
			followTouchMove: false,
			stickyTracking: false,

			pointRange: 0,
			pointPadding: 0,
			groupPadding: 0.1,
			pointPlacement: "between",
			borderWidth: 0,
			cursor: "pointer",
			dataLabels: {
				enabled: true,
				formatter: function () {
					return formatCurrency(this.y);
				},
				style: {
					color: chartDisplaySettings.dataLabelColor,
					fontFamily: chartDisplaySettings.font,
					fontWeight: "normal",
					fontSize: chartDisplaySettings.dataLabelFontSize,
				},
			},
		},
	);

	const that = chartBuilderBase(builderSpec, my);
	my.myself = that;

	my.periodSelection = periodSelection();

	that.setSelectablePoints = function (options) {
		if (options.periodSelection) {
			my.periodSelection = options.periodSelection;
		}
		return that.set("point", {
			events: {
				click: function () {
					my.periodSelection.selectPlotBand(
						this.series.xAxis.plotLinesAndBands,
						this.period,
					);

					if (options && options.onlySeries !== undefined) {
						selectPointsInRange(
							this.series.chart.series[options.onlySeries].points,
							{
								from: this.x,
								to: this.x + 1,
							},
						);
					} else {
						selectPointsInRange(this.series.points, {
							from: this.x,
							to: this.x + 1,
						});
					}

					this.series.xAxis.update();

					if (options && options.onClick) {
						options.onClick(this);
					}
				},
			},
		});
	};

	that.setSelectedPoint = function (options) {
		selectedPointOptions = my.buildOption(options);
		return my.myself;
	};

	that.setPoint = function (options) {
		pointOptions = options;
		return my.myself;
	};

	function selectPointsInRange(points, range) {
		points.forEach((point) => {
			if (
				point.x >= range.from &&
				point.x <= range.to &&
				point.y !== null
			) {
				point.update(selectedPointOptions, true);
			} else {
				point.update(pointOptions, false);
			}
		});
	}

	return that;
}

export default seriesPlotOptionsBuilder;
